/**
 * Javascript file for the registration page.
 * @author Adrian Rebmann, Yannik Sprengart, Steffen Schuhmann
 */

import auth from "../../../../auth";
import {
  required,
  sameAs,
  email,
  minLength,
  maxLength
} from "vuelidate/lib/validators";

export default {
  name: "Signup",

  /**
   * The vue instance's data object.
   * @property {boolean} showSnackbar - Visibility of the snackbar.
   * @property {object} res - The result from a request to the backend.
   * @property {object} form.firstName - The user's first name. 
   * @property {object} form.lastName -The user's last name.
   * @property {object} form.gender - The user's gender.
   * @property {string} form.email - The user's email.
   * @property {string} form.password - The user's password.
   * @property {boolean} form.letter - Users choice for newsletter subscription.
   * @property {boolean} loggedIn - Status of the user's login.
   * @property {boolean} sending - Information is currently being processed.
   */
  data() {
    return {
      res: null,
      form: {
        firstname: null,
        lastname: null,
        gender: null,
        //age: null,
        email: "",
        password: "",
        letter: true
      },
      loggedIn: false,
      sending: false
    };
  },

  /**
   * Validation to be done to the data.
   * @property {*} form.firstName - Validation to be done to the entered first name.
   * @property {*} form.lastName - Validation to be done to the entered last name.
   * @property {*} form.gender - Validation to be done to the entered gender.
   * @property {*} form.email - Validation to be done to the entered email.
   * @property {*} form.password - Validation to be done to the entered password.
   * @property {*} form.repassword - Validation to be done to the entered repassword.
   */
  validations: {
    form: {
      firstname: {
        required,
        minLength: minLength(3)
      },
      lastname: {
        required,
        minLength: minLength(3)
      },
      gender: {
        required
      },
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(8)
      },
      repassword: {
        required,
        sameAsPassword: sameAs("password")
      }
    }
  },

  /**
   * The vue instance's method declaration.
   */
  methods: {
    /**
     * Highlights the email input field.
     */
    focusEmailInput() {
      this.$refs.emailInput.$el.focus();
    },

    /**
     * Determines if the field is invalid or not.
     * @param {string} fieldName - The name of the field.
     */
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];
      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty
        };
      }
    },

    /**
     * Resets the form. 
     */
    clearForm() {
      this.$v.$reset();
      this.form.gender = null;
      this.form.firstname = null;
      this.form.lastname = null;
      this.form.email = null;
      this.form.password = null;
      this.form.repassword = null;
    },

    /**
     * Resets the email field. 
     */
    clearMail() {
      this.form.email = null;
    },

    /**
     * Registers the user. 
     * If the user did not already exist, it redirects to the "registration successful" page.
     * Else, it throws an error.
     */
    register() {
      this.sending = true;
    
      grecaptcha.enterprise.ready(async () => {
        const token = await grecaptcha.enterprise.execute('6LfpiQspAAAAAHIvgAWveLlunRngVIn5w9LPa2LJ', {action: 'register'});
    
        auth.register(
          this.form.email, 
          this.form.password, 
          this.form.firstname, 
          this.form.lastname, 
          this.form.gender, 
          this.form.letter,
          token
        )        
          .then(res => {
            this.sending = false;
            this.$router.push({ name: "SignupSuccess" });
          })
          .catch(err => {
            this.sending = false;
            // handle errors
          });
      });
    }
    ,

    /**
     * Validates the user.
     * If it is valid, it registers the user.
     */
    validateUser() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.register();
      }
    }
  }, 
  
};



// WEBPACK FOOTER //
// ./src/components/app/authentication/signup/signup.js